import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

function DocsRedirect() {
  const navigate = useNavigate();
  const location = useLocation();
  
  useEffect(() => {
    // Preserve hash fragment when redirecting, handling both new and legacy formats
    const hash = location.hash;
    
    if (!hash) {
      // Simple redirect with no hash
      navigate(`/docs`);
      return;
    }
    
    // Legacy format: #section-subsection
    if (!hash.includes('=')) {
      navigate(`/docs${hash}`);
      return;
    }
    
    // New format: Already in #s=section&ss=subsection format
    navigate(`/docs${hash}`);
  }, [navigate, location.hash]);

  return (
    <div className="redirect-container">
      <p>Redirecting to documentation...</p>
    </div>
  );
}

export default DocsRedirect;